import {Injectable} from '@angular/core';
import * as signalR from '@microsoft/signalr';
import {AuthenticationService} from "../authentication.service";
import {IHttpConnectionOptions} from "@microsoft/signalr";
import {LoginHelper} from "../../helpers";

@Injectable({providedIn: 'root'})
export class LogoutHubService {
  private hubConnection!: signalR.HubConnection;

  constructor(
    public authenticationService: AuthenticationService
  ) {
  }

  startConnection(): void {
    const options: IHttpConnectionOptions = {
      accessTokenFactory: () => {
        return LoginHelper.getUserToken();
      },
      transport: signalR.HttpTransportType.LongPolling
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Trace)
      .withUrl('/api/signalr/logoutHub', options)
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('SignalR connection started');
      })
      .catch(err => console.error('Error connecting to SignalR', err));

    this.hubConnection.onclose(() => {
      console.log('Connection lost. Attempting to reconnect...');
      setTimeout(() => this.startConnection(), 3000);  // Try reconnecting after 3 seconds
    });

    this.hubConnection.on('LogoutUser', (userId) => {
      if (!window['logoutProtection']) {
        console.log("Logged in in another tab - logging out");
        this.authenticationService.logout();
      }
    });
  }
}
